//TODO: rid of hard-coded navigation
import React from 'react';
import { Router, Route } from 'react-router-dom';
import history from './history';

import '../assets/css/App.css';
import Home from './pages/Home';
import About from './pages/About';
import Projects from './pages/Projects';
import Sketches from './pages/Sketches';
import Contacts from './pages/Contacts';
import Snakewoman from '../sketches/snakewoman';
import Garden from '../sketches/garden';
import Child from '../sketches/child';
import ClumsyForest from '../sketches/clumsyforest';
import Sentinel from '../sketches/sentinel';
import SpaceOcean from '../sketches/spaceocean';
import SphericalMirrors from '../sketches/sphericalmirrors';
import Incantation from '../sketches/incantation';
import ThreeBone from '../sketches/threebone';
import ArmFoot from '../sketches/armfoot';
import Mira from '../sketches/mira';
import Broken from '../sketches/broken';
import Thought from '../sketches/thought';
import Christmas from '../sketches/christmas';
import LiquidBody from '../sketches/liquidbody';
import Underwater from '../sketches/underwater';
import Tiny from '../sketches/tiny';

import MoF from '../projects/meaningOfGame';
import Fantasynth from '../projects/fantasynth';
import Lichtspektakel from '../projects/lichtspektakel';
import GameAsPerformance from '../projects/gameAsPerformance';


class App extends React.Component {
  render() {
    return (
      <div className="App">
        <Router history={history}>
          <Route exact path="/" component={Home} />
          <Route exact path="/about" component={About} />
          <Route exact path="/projects" component={Projects} />
          <Route exact path="/webgl" component={Sketches} />
          {/* <Route path="/webgl/:sketch" component={ OpenSketch } />  */}
          <Route exact path="/webgl/snakewoman" component={Snakewoman} />
          <Route exact path="/webgl/garden" component={Garden} />
          <Route exact path="/webgl/spaceocean" component={SpaceOcean} />
          <Route exact path="/webgl/sentinel" component={Sentinel} />
          <Route exact path="/webgl/child" component={Child} />
          <Route exact path="/webgl/clumsyforest" component={ClumsyForest} />
          <Route exact path="/webgl/sphericalmirrors" component={SphericalMirrors} />
          <Route exact path="/webgl/incantation" component={Incantation} />
          <Route exact path="/webgl/threebone" component={ThreeBone} />
          <Route exact path="/webgl/armfoot" component={ArmFoot} />
          <Route exact path="/webgl/mira" component={Mira} />
          <Route exact path="/webgl/broken" component={Broken} />
          <Route exact path="/webgl/thought" component={Thought} />
          <Route exact path="/webgl/ritaschristmas" component={Christmas} />
          <Route exact path="/webgl/liquidbody" component={LiquidBody} />
          <Route exact path="/webgl/underwater" component={Underwater} />
          <Route exact path="/webgl/tiny" component={Tiny} />

          <Route exact path="/projects/meaningofgame" component={MoF} />
          <Route exact path="/projects/gameasperformanceart" component={GameAsPerformance} />
          <Route exact path="/projects/fantasynth" component={Fantasynth} />
          <Route exact path="/projects/lichtspektakel" component={Lichtspektakel} />

          <Route exact path="/contacts" component={Contacts} />
        </Router>
      </div>
    );
  };
}

export default App;
